<template src="./PageLoader.html">
</template>

<script>
export default {
    name: 'Loader',
    props: {
        isLoading: false
    }
}
</script>
